import { motion } from 'framer-motion';

function Reveal({ as = 'div', children, className, delay = 0, y = 28 }) {
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.22 }}
      transition={{ delay, duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </Component>
  );
}

export default Reveal;
